exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputW_843db05{width:230px!important}.fontStyle_613be58{font-size:13px;font-weight:700}.textarea_b07a50b{width:400px!important;height:150px}.textarea_b07a50b .k-textarea{height:150px!important;resize:none}", ""]);

// exports
exports.locals = {
	"inputW": "inputW_843db05",
	"fontStyle": "fontStyle_613be58",
	"textarea": "textarea_b07a50b"
};